import { render } from "./starter-tabs.vue?vue&type=template&id=0030c87a"
import script from "./starter-tabs.vue?vue&type=script&lang=js"
export * from "./starter-tabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__